// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d6af7db4","655":"6738d423","977":"e0495511"}[chunkId] + ".chunk.js";
};